export const tabStyle = (min) => ({
    flexGrow: 1,
    minWidth: min,
    padding: {
        xs: '4px',
        sm: '8px',
        md: '10px',
        lg: '12px',
    },
})

export const tabIndicatorStyles = {
    sx: {
        // width: "20% !important",
        backgroundColor: 'white',
        height: '2px'
    }
};
export const menuStyle = {
    borderBottom: 1,
    width: '100%',
    display: "flex",
    borderColor: 'divider',
    padding: '8px',
};

export const scrollButtonStyle = {
    sx: {
        color: 'white',
        fontSize: '2rem', // Increase arrow size
        '& svg': {
            fontSize: '2.0rem' // Specifically increase icon size
        }
    }
}


export const tabName = {
    fontFamily: 'Jost-Regular',
    fontSize: '20px',
    color: 'white',
    // letterSpacing: '0px',
    '@media (min-width:600px)': {
        fontSize: '1.5rem',
    },
}
